export default __webpack_public_path__ + "static/media/learning-group-mobile.c77fa3ec.png";